module.exports = __webpack_public_path__ + "static/media/micActive.7321e038.svg";